import { notFound } from "@tanstack/react-router";
import { buildHref, matchRoute } from "@softmax/web-addresses";
import { requireGameContext } from "@/features/game/data";

export async function getEditorRedirect({
  data,
  signal,
}: {
  data: { href: string };
  signal?: AbortSignal | undefined;
}) {
  const url = new URL(data.href, window.location.origin);

  if (
    url.origin !== window.location.origin ||
    matchRoute(url.pathname).name !== "game.previewEdit"
  )
    throw notFound();

  const context = await requireGameContext({ href: data.href, signal });
  const search = new URLSearchParams(url.searchParams);
  search.set("edit", "1");
  return buildHref({
    name: "game.preview",
    game: context.address,
    search,
    hash: url.hash,
  });
}
